import { CustomerType } from "@origin-digital/platform-enums";
import { getMcAppFromBaseProps } from "../lib/baseProps";
import { IBaseProps, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const createRefundsMcApp = ({ name, ...props }: IBaseProps): IMcAppType[] => {
  return [
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_MAGICLINK`,
      magiclinkPath: "/task/refunds",
      intent: name,
    }),
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_SAP`,
      path: "/my-account/transfer-refund-credit",
      intent: name,
      customerType: CustomerType.sap,
    }),
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_KRAKEN`,
      path: "/my/feedback/\\?formCode=rx_refund&title=Refund%20my%20credit",
      intent: name,
      customerType: CustomerType.kraken,
      ignorePathMapping: true,
    }),
  ];
};

const refundsApp: IBaseProps[] = [
  {
    name: "refunds",
    path: "",
    subPath: "",
    description: "Refunds",
    navFlow: NavFlow.FOCUS,
    title: "Refunds",
    parent: Tab.MORE,
  },
];

export const refunds: IMcAppType[] = refundsApp.flatMap((app) =>
  createRefundsMcApp(app)
);
